import _Promise from 'babel-runtime/core-js/promise';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import material from './material.vue';
import materialList from './materialList.vue';
import offerList from './offerList.vue';
import Pagination from '@/components/Pagination/index.vue';
import { getReviewList } from '@/api/creative/review';
import RelateReview from './relate-review.vue';
import { spliceAuditReasons, convertCreativeType, cookSearchParams, isPlayable as _isPlayable } from './review.js';
import SearchBar from './search.vue';
import searchMixin from '@/mixin/search';
import { FormItemMixin } from './mixin/formItem.js';
import { getSuggestList as _getSuggestList } from '@/api/creative/review';
import { getReviewInfo } from '@/api/creative/review';
import { getDcoDetail } from '@/api/common/dco';
import ReviewMaterial from './reviewMaterial.vue';
import BatchReviewMaterial from './batchReviewMaterial.vue';
import { submitReview } from '@/api/creative/review';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { format } from 'date-fns';
import { cookRequestParams } from '@/common/request';

var dayTime = 1000 * 60 * 60 * 24;
var _defaultTime = [format(new Date() - dayTime * 6, 'YYYY-MM-DD') + ' 00:00:00', format(new Date(), 'YYYY-MM-DD') + ' 23:59:59'];

var defaultQuery = {
  page: 1,
  page_size: 15,
  status: 1,
  offer_field: 'uuid',
  offer_field_value: '',
  campaign_name: '',
  from_platform: '',
  platform: '',
  offer_type: '',
  adv_name: '',
  adv_grade: '',
  is_dco: '',
  creative_field: 'id',
  creative_id: '',
  creative_name: '',
  creative_type: '',
  offer_geo: '',
  creative_geo: '',
  re_review: '',
  review: '',
  operator: '',
  draft_operator: '',
  id: '',
  pm: '',
  search_time: 'update_time',
  time: [].concat(_defaultTime),
  pm_teams: '',
  ai_status_in: '',
  reason_ids: [],
  audit_result: '',
  creative_id_unique: '',
  remark: '',
  material_gradings: [],
  priority: '',
  audit_remarks: '',
  uniq_adv_pkg_md5: ''
};

export default {
  mixins: [searchMixin, FormItemMixin],

  components: {
    ReviewMaterial: ReviewMaterial,
    material: material,
    materialList: materialList,
    Pagination: Pagination,
    SearchBar: SearchBar,
    offerList: offerList,
    BatchReviewMaterial: BatchReviewMaterial,
    RelateReview: RelateReview
  },

  data: function data() {
    var platformOptions = [{
      label: 'iOS',
      value: 'ios'
    }, {
      label: 'Android',
      value: 'android'
    }];

    return {
      query: _extends({}, defaultQuery),
      selectDate: '',
      draftForm: {
        notes: ''
      },
      draftRules: {
        notes: [{
          required: true,
          message: '请输入备注',
          trigger: 'blur'
        }]
      },
      list: [],
      countryList: [],
      listLoading: false,
      totalLoading: false,
      relateList: [],

      pagination: {
        total: 0
      },

      platformOptions: platformOptions,

      tabs: {
        current: 'pending（初审）',
        list: [{
          name: 'pending（初审）',
          value: 1
        }, {
          name: 'draft（草稿）',
          value: 6
        }, {
          name: 'Cross-Review（复审）',
          value: 5
        },
        // ss 上传素材测试中状态
        {
          name: 'Testing（测试中）',
          value: 4
        }, {
          name: 'Audit Result（审核结果）',
          value: '2,3'
        }, {
          name: 'Re-Review（巡审）',
          value: 7
        }, {
          name: '机器审核',
          value: 8
        }, {
          name: '素材关联OFFER',
          value: 'offer'
        }]
      },

      auditDialog: {
        visible: false,
        batch: '',
        batchType: '',
        title: '审核素材'
      },

      draftDialog: {
        visible: false,
        data: {}
      },

      isBatchReview: false,

      materialDialog: {
        visible: false,
        title: '素材名字'
      },
      currentMaterial: {},
      currentDcoList: [],
      advId: 0,
      pmId: 0,
      machineAudit: {} // 机审结果
    };
  },


  computed: {
    isPlayable: function isPlayable() {
      return _isPlayable(this.currentMaterial.creative_type);
    }
  },

  watch: {
    $route: function $route(to, from) {
      var status = to.query.status;
      if (!status || ![1, '2,3', 4, 5, 6, 7, 8, 'offer'].some(function (item) {
        return item === status || item === Number(status);
      })) {
        this.query.status = 1;
      }
      if (!to.query.time || to.query.time && to.query.time.length === 0) {
        this.query.time = [].concat(_defaultTime);
      }
      this.query.reason_ids = this.query.reason_ids.map(String);
      this.getMaterialList();
    },
    currentMaterial: function currentMaterial(material) {
      this.materialDialog.title = material.creative_name;
    },
    'query.offer_field': function queryOffer_field(val) {
      this.query.offer_field_value = '';
    },
    'query.creative_field': function queryCreative_field(val) {
      this.query.creative_field_id = '';
      this.query.creative_field_name = '';
    },
    'materialDialog.visible': function materialDialogVisible(val) {
      if (val === false) this.currentMaterial = {};
    },
    'auditDialog.visible': function auditDialogVisible(val) {
      if (val === false) {
        this.currentMaterial = {};
        this.machineAudit = {};
        this.getMaterialList();
      }
    },
    'draftDialog.visible': function draftDialogVisible(val) {
      if (val === false) {
        this.$refs['draft-form'].resetFields();
      }
    },
    'query.status': function queryStatus(val) {
      if (!val) {
        this.tabs.current = 'pending（初审）';
      } else {
        this.tabs.current = this.tabs.list.filter(function (item) {
          return item.value === val || item.value === Number(val);
        })[0].name;
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.query.time = [].concat(_defaultTime);
              _this.query.reason_ids = _this.query.reason_ids.map(String);
              _context.next = 4;
              return _this.getDependencyData();

            case 4:
              _context.next = 6;
              return _this.getMaterialList();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    getDependencyData: function getDependencyData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _ref, _ref2, _ref2$, countryList;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _Promise.all([_this2.$store.dispatch('config/getCountryList')]);

              case 2:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 1);
                _ref2$ = _ref2[0];
                countryList = _ref2$ === undefined ? [] : _ref2$;

                _this2.countryList = countryList.map(function (item) {
                  return {
                    value: item.value,
                    label: item.label + (' (' + item.value + ')')
                  };
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    processDraft: function processDraft(material) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var validate;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$refs['draft-form'].validate();

              case 2:
                validate = _context3.sent;

                if (validate) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt('return');

              case 5:
                _context3.next = 7;
                return submitReview({
                  ids: String(material.id),
                  status: 6,
                  notes: _this3.draftForm.notes
                });

              case 7:
                _this3.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                _this3.draftDialog.visible = false;
                _this3.getMaterialList();

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getSuggestList: function getSuggestList(params, cb) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res, suggestList;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(params.keyword === '')) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                _context4.next = 4;
                return _getSuggestList(params);

              case 4:
                res = _context4.sent;
                suggestList = _.get(res, 'data.data.result') || [];

                cb(suggestList.map(function (item) {
                  return {
                    value: item.name
                  };
                }));

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getPublishInfo: function getPublishInfo(item) {
      return JSON.parse(item.publish_info);
    },
    getMaterialList: function getMaterialList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var creative_md5_arr, res, _materialList, totalParams, totalRes;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.listLoading = true;
                creative_md5_arr = [];
                _context5.prev = 2;
                _context5.next = 5;
                return getReviewList(_extends({}, cookSearchParams(_this5.query)));

              case 5:
                res = _context5.sent;
                _materialList = (_.get(res, 'data.data.list') || []).map(function (material) {
                  // 拼接 reason_ids 对应的原因与 reason_text
                  if (material.reason_ids || material.reason) {
                    material.reject_reason = spliceAuditReasons(
                    // eslint-disable-line
                    material.reason_ids, material.reason);
                  }
                  // eslint-disable-next-line
                  material.creative_type = convertCreativeType(material.creative_type);
                  // 草稿内容
                  var content = material.draft_notes ? JSON.parse(material.draft_notes) : {};

                  material.draft_note = content.message || '';
                  material.draft_operator = content.username || '';
                  material.draft_time = content.time || '';
                  var extInfo = material.ext_info ? JSON.parse(material.ext_info) : {};
                  material.ext_market_url = extInfo.market_url || '';

                  // 当前页有多条Md5相同的素材时，除第一条外，审核ID标红
                  if (material.creative_md5) {
                    if (creative_md5_arr.indexOf(material.creative_md5) === -1) {
                      creative_md5_arr.push(material.creative_md5);
                    } else {
                      material.creative_md5_warn = true;
                    }
                  }
                  return material;
                });

                _this5.list = _materialList;

                _this5.listLoading = false;
                totalParams = _extends({}, cookSearchParams(_this5.query), {
                  get_total: 2
                });
                _context5.next = 12;
                return getReviewList(totalParams);

              case 12:
                totalRes = _context5.sent;

                _this5.pagination.total = _.get(totalRes, 'data.data.total');
                _context5.next = 19;
                break;

              case 16:
                _context5.prev = 16;
                _context5.t0 = _context5['catch'](2);

                _this5.listLoading = false;

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[2, 16]]);
      }))();
    },
    handleExport: function handleExport() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var params, path;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                params = cookRequestParams(cookSearchParams(_this6.query));

                delete params.page_size;
                console.log(params);
                path = v2Host + '/creative/review/export?' + qs.stringify(params);

                window.open(path, '_blank');

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      console.log('\u591A\u9009\u64CD\u4F5C\u7ED3\u679C\uFF1A');
      console.log(val.map(function (item) {
        return item.id;
      }).join());
      this.auditDialog.batch = val.map(function (item) {
        return item.id;
      }).join();
    },
    handleBatchAction: function handleBatchAction(type) {
      if (type === 'draft') {
        this.showDraftDialog('', true);
      } else {
        this.auditDialog.batchType = type;
        this.showAuditDialog({ isBatchReview: true });
      }
      if (type === 'material_grading') {
        this.auditDialog.title = '批量修改素材分级';
      } else {
        this.auditDialog.title = '审核素材';
      }
    },
    showDraftDialog: function showDraftDialog(material, isBatch) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.relateList = [];

                if (!isBatch) {
                  _context7.next = 5;
                  break;
                }

                _this7.draftDialog.data = {
                  id: _this7.auditDialog.batch // 审核id
                };
                _context7.next = 8;
                break;

              case 5:
                _context7.next = 7;
                return _this7.fetchReviewDetail(material.id);

              case 7:
                _this7.draftDialog.data = material;

              case 8:
                _this7.draftDialog.visible = true;

              case 9:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },


    // 展示审核弹窗，同时检查展示类型，判断是否清除批量选项
    showAuditDialog: function showAuditDialog(_ref3) {
      var _this8 = this;

      var material = _ref3.material,
          isBatchReview = _ref3.isBatchReview;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var data, docRes;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.isBatchReview = isBatchReview || false;

                if (!material) {
                  _context8.next = 14;
                  break;
                }

                // 非批量处理，清空批量处理选项
                _this8.currentMaterial = material;
                _this8.auditDialog.batch = '';
                _this8.auditDialog.batchType = '';
                _this8.relateList = [];
                _this8.currentDcoList = [];
                _this8.fetchReviewDetail(material.id);
                // 获取dco列表

                if (!((_this8.isPlayable || material.creative_type === 'video') && material.is_dco === 1)) {
                  _context8.next = 14;
                  break;
                }

                data = JSON.parse(_.get(material, 'ext_info'));
                _context8.next = 12;
                return getDcoDetail({
                  id: material.dco_id,
                  version: data.dco_version
                });

              case 12:
                docRes = _context8.sent;

                _this8.currentDcoList = _this8.cookCreatives(_.get(docRes.data.data, 'creatives')) || [];

              case 14:

                _this8.$nextTick(function () {
                  _this8.auditDialog.visible = true;
                });

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    cookCreatives: function cookCreatives(list) {
      var _this9 = this;

      var temp = [];
      if (list.length) {
        list.map(function (i) {
          if (_this9.currentMaterial.creative_type === 'video') {
            var item = _extends({}, i);
            item.gid = i.gid;
            item.dco_ids = i.id;
            delete item.id;
            temp.push(item);
          } else {
            JSON.parse(i.groups).map(function (k) {
              var item = _extends({}, i);
              item.gid = k.gid;
              item.dco_ids = item.id;
              delete item.id;
              temp.push(item);
            });
          }
        });
        //
      }
      return temp;
    },
    fetchReviewDetail: function fetchReviewDetail(id) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var res;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return getReviewInfo(id);

              case 2:
                res = _context9.sent;

                _this10.relateList = _.get(res, 'data.data.related') || [];
                _this10.advId = _.get(res, 'data.data.info.adv_id');
                _this10.pmId = _.get(res, 'data.data.info.pm_id');
                _this10.machineAudit = _.get(res, 'data.data.machine_audit');

              case 7:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    },
    hideAuditDialog: function hideAuditDialog() {
      this.currentMaterial = {};
      this.auditDialog.visible = false;
    },
    showMaterialDialog: function showMaterialDialog(material) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var data, docRes;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this11.currentMaterial = material;
                _this11.currentDcoList = [];
                _this11.fetchReviewDetail(material.id);
                // 获取dco列表

                if (!((_this11.isPlayable || material.creative_type === 'video') && material.is_dco === 1)) {
                  _context10.next = 9;
                  break;
                }

                data = JSON.parse(_.get(material, 'ext_info'));
                _context10.next = 7;
                return getDcoDetail({
                  id: material.dco_id,
                  version: data.dco_version
                });

              case 7:
                docRes = _context10.sent;

                _this11.currentDcoList = _this11.cookCreatives(_.get(docRes.data.data, 'creatives')) || [];

              case 9:
                _this11.materialDialog.visible = true;

              case 10:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, _this11);
      }))();
    },
    hideMaterialDialog: function hideMaterialDialog() {
      this.currentMaterial = {};
      this.materialDialog.visible = false;
    },
    handleTabClick: function handleTabClick(tab) {
      this.query.audit_result = '';
      this.query.review = '';
      this.query.re_review = '';
      var tabName = tab.name.toLowerCase();
      var status = this.tabs.list.filter(function (item) {
        return item.name === tab.name;
      })[0].value;
      this.query.creative_id_unique = status === '2,3' ? 1 : '';

      this.query.priority = status === 7 ? 1 : '';

      if (this.query.creative_name) {
        this.query.creative_field = 'name';
      }

      this.list = [];
      this.$router.push({
        name: 'butler.review',
        params: { type: tabName },
        query: _extends({}, this.query, {
          page: 1,
          status: status
        })
      });
    },
    resetSearch: function resetSearch() {
      if (this.tabs.current === '素材关联OFFER') {
        this.query.creative_name = '';
        this.getMaterialList();
      } else {
        this.query = _extends({}, defaultQuery, {
          status: this.query.status
        });
        this.handleResetSearch();
      }
    }
  }
};